import React from "react"
import { auditShape } from "utils/propTypeShapes"
import TaskLink from "../TaskLink"

const TaskCreatedAuditItemDetails = ({ audit }) => {
  const { formSubmissionSlug, task } = audit

  return (
    <div>
      Created <TaskLink task={task} formSubmissionSlug={formSubmissionSlug} />.
    </div>
  )
}

TaskCreatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default TaskCreatedAuditItemDetails
